module.exports = __webpack_public_path__ + "static/media/check_badge.7bfe22e2.svg";